module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app-download"
    }
  }, [(_vm.modal.screenIsOpen) ? _c('app-download-modal', {
    on: {
      "toggle": _vm.toggleModal
    }
  }, [_c('div', {
    staticClass: "app-download-body"
  }, [_c('div', {
    staticClass: "leads-app-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/leads-app.png"),
      "alt": "Leads App"
    }
  })]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('ui.modals.download_app.title')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ui.modals.download_app.subtitle')))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://apps.apple.com/us/app/hileadzz/id1344775133",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "app-store-btn",
    attrs: {
      "src": require("../../../assets/apple-btn.png"),
      "alt": "Appel Store"
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=de.fanomena.hileadzz.cordovaapp&hl=en",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "app-store-btn",
    attrs: {
      "src": require("../../../assets/google-btn.png"),
      "alt": "Google Store"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [_c('p', {
    attrs: {
      "id": "finish"
    },
    on: {
      "click": _vm.finish
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.modals.download_app.skip')))])]), _vm._v(" "), _c('div', {
    staticClass: "back-actions"
  })])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47be6ba2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/partials/AppDownloadScreen.vue
// module id = 1892
// module chunks = 0